export default __webpack_public_path__ + "static/media/IMG_0686.1f737654.jpeg";